<div class="row dealer-info-list-item">
  <div class="col-12">
    <div class="locate-dealer-item {{language}}">
      
      <div class="d-flex flex-column">
        <div class="gb-body3 heavy mb-2 d-flex" *ngIf="!isGuestMode && preferredDealer && preferredDealer.id === dealer.id">
          <span aria-hidden="true" class="icon-graphic-star yellow-text">&nbsp;</span>
          <p class="mb-0" role="heading" aria-level="3" [translate]="cmsPrefix+'_preferredDealer_yourPreferredDealer'"></p>
        </div>


        <div class="d-flex">
          <img *ngIf="dealer.markerIcon"
                [attr.src]="dealer.markerIcon | link"
                role="presentation"
                aria-label="'map_pin_aria_label' | translate"/>
          <div class="dealer-name-address">
            <div class="gb-body2 heavy" role="heading" aria-level="3">
              <p class="mb-0">{{dealer.name}}</p>
            </div>
            <ul class="{{language}}">
              <li class="gb-body3 mb-0">{{dealer.street}}</li>
              <li class="gb-body3 mb-0">{{dealer.city}}, {{dealer.state}} {{dealer.zipCode}}</li>
              <li class="gb-body3 mb-0">{{dealer.zipCode}}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="locate-dealer-status {{language}}">
        <div class="gb-body3 heavy mb-0" role="heading" aria-level="3" [hidden]="!dealer.distance">
          <p class="mb-0">{{dealerDistance}} <span [translate]="'locateDealer_dealer_distanceAway'"></span></p>
        </div>
      </div>

    </div>

    <div class="col-12">
      <hr class="light">
    </div>

    <div class="col-12">
      <ul class="{{language}} mb-4 md-lg-2">
        <li class="mb-2">
          <div class="gb-body2 heavy">
            <p class="mb-0" [translate]="cmsPrefix+'_dealer_salesPhoneLabel'"></p>
          </div>
          <div class="gb-body2">
            <a class="noBold noWrap"
            href="tel:+{{dealer.salesPhone}}"
            oxTrackLink
            [trackLink]="trackLinkPrefix+': Sales Phone Number'"
            [trackDelay]="'true'"
            [trackType]="'o'"
            [prop10]="prop10Prefix+':link:sales phone number:'+dealer.name+':'+dealer.salesPhone">
            {{dealer.salesPhone}}
            </a>
          </div>
        </li>

      <li class="mb-0">
        <div class="gb-body2 heavy">
          <p class="mb-0" [translate]="cmsPrefix+'_dealer_servicePhoneLabel'"></p>
        </div>
        <div class="gb-body2">
          <a class="noBold noWrap"
              href="tel:+{{dealer.servicePhone}}"
              oxTrackLink
              [trackLink]="trackLinkPrefix+': Service Phone Number'"
              [trackDelay]="'true'"
              [trackType]="'o'"
              [prop10]="prop10Prefix+':link:service phone number:'+dealer.name+':'+dealer.servicePhone">
            {{dealer.servicePhone}}
          </a>
        </div>
      </li>
    </ul>
    <ul class={{language}}>
      <li *ngIf="dealer.dealerWebSite"
          oxTrackLink
          [trackLink]="trackLinkPrefix+':DealerWebsite'"
          [trackDelay]="'this'"
          [trackType]="'e'"
          [prop10]="prop10Prefix+':link:dealer website'"
          class="gb-body2">
        <a class="noWrap dealerWebsiteLink"
            href="{{dealer.dealerWebSite}}"
            disabled="!dealer.certifiedInternet"
            aria-haspopup="dialog"
            aria-expanded="false"
            [attr.aria-label]="dealer.name + ('aoda_open_new_window_aria_label' | translate)">
          <span [translate]="cmsPrefix+'_dealerWebsite'"></span>&nbsp;
          <span role="presentation" class="icon-ui-newwindow"></span>
        </a>
      </li>
      <li oxTrackLink
          [trackLink]="trackLinkPrefix+':ViewInfo'"
          [trackDelay]="'true'"
          [trackType]="'o'"
          [prop10]="prop10Prefix+':link:view dealer info'">
        <button class="gb-secondary-button noWrap col-12 col-lg-6"
                (click)="goToState('viewDealerInfo')"
                [disabled]="!dealer.certifiedInternet"
                [translate]="cmsPrefix+'_preferredDealer_viewDealerInfo'"
                aria-haspopup="dialog"
                aria-expanded="false">
        </button>
      </li>
    </ul>
  </div>

  <div class="col-12 mt-4" [hidden]="dealerHideSpecialServices">
    <div class="gb-body2 heavy">
      <p class="mb-0" [translate]="cmsPrefix+'_dealer_specialtyServicesLabel'"></p>
    </div>
    <ul class="list-styled" *ngFor="let service of dealer.specialtyServices">
      <li class="mb-0">
        <div class="gb-body3">
          <p class="mb-0">{{service}}</p>
        </div>
      </li>
    </ul>
  </div>

  <div class="col-12">
    <hr class="light">
  </div>

  <div class="col-12">
    <ul class={{language}}>
      <li class="mb-2"
          oxTrackLink
          [trackLink]="trackLinkPrefix+':GetDirections'"
          [trackDelay]="'true'"
          [trackType]="'o'"
          [prop10]="prop10Prefix+':button:get directions'">
        <button class="gb-primary-button {{language}} col-12 col-lg-6"
                (click)="goToState('directions')"
                [translate]="cmsPrefix+'_directions_getDirectionsBtn'">
        </button>
      </li>
      <li class="mb-0" *ngIf="!isGuestMode && preferredDealer && preferredDealer.id !== dealer.id">
          <button class="gb-secondary-button {{language}} col-12 col-lg-6"
                  (click)="goToState('goToPreferredDealer')"
                  [disabled]="!dealer.certifiedInternet"
                  [trackLink]="trackLinkPrefix+':MakePreferred'"
                  [trackDelay]="'true'"
                  [trackType]="'o'"
                  [prop10]="prop10Prefix+':button:Make this my Preferred Service Dealer'">
              <span aria-hidden="true" class="col-xs-1 icon-graphic-offers">&nbsp;</span>
              <span tabindex="0" class="col-xs-10 MakePreferredDealerButton" [translate]="cmsPrefix+'_preferredDealer_makeMyPreferred'"></span>
          </button>
      </li>

      <li [trackLink]="trackLinkPrefix+':ScheduleService'"
          [trackDelay]="'this'"
          [trackType]="'e'"
          [prop10]="prop10Prefix+':button:schedule service'"
          class="gb-body1 mt-2">
        <a class="large-list {{language}} noWrap ScheduleServiceButton" (click)="loadOss()">
          <span class="icon-graphic-service">&nbsp;</span>
          <span [translate]="cmsPrefix+'_scheduleServiceBtn'"></span>
        </a>
      </li>
    </ul>
  </div>
</div>
